import React, { useState, useEffect, useCallback, useRef } from 'react'
import { ThreeDots } from 'react-loader-spinner';
import authApiService from "../services/authServices";
import { Link } from 'react-router-dom';
import { formatSeasonDisplayName } from "../utils/seasonName";

function Champions() {
   const [champions, setChampions] = useState([]);
   const [year, setYear] = useState(() => new Date().getFullYear());
   // True until the first response arrives, so "No champions data" never flashes while loading.
   const [isLoading, setIsLoading] = useState(true);
   const latestRequest = useRef(0);

   const fetchChampions = useCallback(async (selectedYear) => {
      const requestId = ++latestRequest.current;
      setIsLoading(true);
      try {
         const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
         const cityId = selectedCity?.id;

         if (!cityId) {
            console.warn("City ID not available");
            setChampions([]);
            return;
         }

         const response = await authApiService.get(`champions?cityId=${cityId}&year=${selectedYear}`);

         // Ignore a slower, older response (e.g. year changed while loading).
         if (requestId !== latestRequest.current) return;

         if (Array.isArray(response.data)) {
            setChampions(response.data);
         } else {
            setChampions([]);
         }
      } catch (error) {
         console.error("Error fetching champions:", error);
         if (requestId === latestRequest.current) setChampions([]);
      } finally {
         if (requestId === latestRequest.current) setIsLoading(false);
      }
   }, []);

   // Fetch for everyone (guest + member + admin). Do NOT gate on role — guests have role=null
   // and would otherwise never load champions.
   useEffect(() => {
      fetchChampions(year);
   }, [year, fetchChampions]);

   const currentYear = new Date().getFullYear();
   const years = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3];

   const handleYearChange = (e) => {
      const selectedYear = Number(e.target.value);
      setYear(selectedYear);
   };

   const homeCourtTitle = (court) => {
      if (court == null || court === "") return undefined;
      if (typeof court === "string") {
         const t = court.trim();
         return t || undefined;
      }
      return String(court);
   };

   const formatPlayerLevel = (level) => {
      if (level == null || level === "") return "—";
      const n = Number(level);
      if (!Number.isNaN(n) && Number.isInteger(n)) return n.toFixed(1);
      return String(level).trim() || "—";
   };

   return (
      <div className="page-container col-sm-9 mb-5">
         <style>{`
            .champion-section .champion-card {
               min-width: 0;
               overflow: hidden;
            }
            .champion-home-court-row {
               display: flex;
               align-items: baseline;
               gap: 0.35rem;
               min-width: 0;
               max-width: 100%;
            }
            .champion-home-court-row .champion-home-court-label {
               flex-shrink: 0;
            }
            .champion-home-court-row .champion-home-court-value {
               min-width: 0;
               flex: 1;
               overflow: hidden;
               text-overflow: ellipsis;
               white-space: nowrap;
            }
            .champion-home-court-row .champion-home-court-value a {
               display: block;
               overflow: hidden;
               text-overflow: ellipsis;
               white-space: nowrap;
            }
         `}</style>
         <div className="section">
            <div className="left">
            </div>
            <div className="year-heading champions-page-heading py-3 px-3">
               <div className="row align-items-center">
                  <div className="col-sm-6">
                     <h6 className="text-white">Champions {year}</h6>
                  </div>
                  <div className="col-sm-6">
                     <div className="cham-year-drop mt-3 mt-sm-0">
                        <form name="chooseYear" className="text-left text-sm-right">
                           <select
                              id="changeYear"
                              name="changeYear"
                              value={year}
                              onChange={handleYearChange}
                              className="form-select"
                           >

                              <option value="" disabled>Change Year</option>
                              {years.map((yr) => (
                                 <option key={yr} value={yr}>
                                    {yr}
                                 </option>
                              ))}
                           </select>
                        </form>
                     </div>

                  </div>
               </div>

            </div>
         </div>

         <div className="champion-section">
            <div className="row">
               {isLoading ? (
                  <div
                     className="col-12 champions-loading"
                     style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 240 }}
                  >
                     <ThreeDots height="80" width="80" radius="9" color="#4fa94d" ariaLabel="three-dots-loading" visible={true} />
                  </div>
               ) : champions.length > 0 ? (
                  champions.map((champion, index) => (
                     <div key={index} className="threecol-frame col-xl-3 col-lg-4 col-sm-6 frame-box mb-4">
                        <div className="card champion-card">
                           <div className="center my-0"><img src="/images/trophy-icon.png" alt="member" /></div>
                           <div className="center mt-3 mb-2">
                              <div className="buttonwrapper"><Link to={`/carter/profile?userId=${champion.player}`} className="squarebutton ie-post-link"><span>View Profile</span></Link></div>
                           </div>
                           <div className="center my-0">
                              <h2>&nbsp;<strong>{champion.leauge_winner}</strong></h2>
                           </div>
                           <div className="clear"></div>
                           <p className="champ-info center mt-2">City Champion</p>
                           <p className="champ-info center mt-0 mb-2">{formatSeasonDisplayName(champion.season)}</p>
                           <p  className="overflowText"
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}>Home Court:
                              <span
                                 className="champion-home-court-value"
                                 title={homeCourtTitle(champion.court)}
                              >
                                 {champion.court && String(champion.court).trim()
                                    ? champion.court
                                    : "—"}
                              </span>
                           </p>

                           <p>Rating: {formatPlayerLevel(champion.player_level)}</p>
                           <p>
                              Season Record:{" "}
                              <Link
                                 to="/carter/members/record"
                                 state={{ memberId: champion.player, recordType: "tournament" }}
                                 className="ie-post-link"
                              >
                                 {champion.record}
                              </Link>
                           </p>
                        </div>
                     </div>
                  ))
               ) : (
                  <div className="col-12">
                     <p className="text-center">No champions data available for this year.</p>
                  </div>
               )}
            </div>
         </div>
      </div>
   )
}

export default Champions